export default "__VITE_ASSET__0fe474bb__"